import { render, staticRenderFns } from "./LaroldImg.vue?vue&type=template&id=cf2eda36&scoped=true&"
import script from "./LaroldImg.vue?vue&type=script&lang=ts&"
export * from "./LaroldImg.vue?vue&type=script&lang=ts&"
import style0 from "./LaroldImg.vue?vue&type=style&index=0&id=cf2eda36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2eda36",
  null
  
)

export default component.exports